export class Wetter {
  constructor({
    code,
    minTemperatur,
    maxTemperatur,
  }: {
    readonly code?: number;
    readonly minTemperatur?: number;
    readonly maxTemperatur?: number;
  }) {
    this.code = code;
    this.minTemperatur = minTemperatur;
    this.maxTemperatur = maxTemperatur;
  }

  readonly code?: number;
  readonly minTemperatur?: number;
  readonly maxTemperatur?: number;
}
